var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ev-color-picker-item",class:{ show: _vm.show },style:(("background: " + (_vm.color.hex) + "; transition-delay: " + ((_vm.show ? _vm.i : 0) * 0.1) + "s")),on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }